// extracted by mini-css-extract-plugin
module.exports = {"top-menu":"styles_top-menu__gfztv","settings-button":"styles_settings-button__2oH6k","top-menu-navbar":"styles_top-menu-navbar__3Opn4"};